const DeleteOrder = {
    template: `<h3>${langhelp.delete.title}</h3>
               <div v-if="error">
                    <p v-text="error" class="alert alert-danger" role="alert"></p>
                </div>
                <div class="text-center">
                   <div class="fs-1 my-3">${langhelp.delete.question}</div>
                   <div>
                        <button class="btn btn-primary mr-3" @click="$emit('refresh')">${langhelp.delete.no}</button>
                        <button class="btn btn-white" @click="handleSubmit" :class="{'loading-spin':loading}" :disabled="loading"><span>${langhelp.delete.yes}</span></button>
                   </div>
               </div>`,
    props: ["order-id"],
    data() {
        return {
            loading: false,
            error:null,
        };
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            const response = await fetch(
                `/api/orders/${this.orderId}/deny`,
                {
                    method: "POST",
                    headers: http.headers(),
                    body: JSON.stringify({
                        operation: "delete",
                        token: Cookies.getItem("login_token"),
                    }),
                }
            ).catch((err) =>{
                console.log(err);
                this.loading = false;
            });
            const data = await response.json();
            this.loading = false;

            if (!response.ok) {
                this.error =data.error;
                return;
            }

            this.$emit('success');
            //this.$emit("refresh");
        },
    }
};

export default DeleteOrder;

// let eld = document.createElement('div');
// eld.innerHTML = DeleteOrder.template;
// eld.id = "deleteOrder";
// document.getElementById('helpModule').appendChild(eld);

// const deleteOrderApp = Vue.createApp({
//     name: 'HelpMore',
//     data() {
//         return {
//             id: null,
//         };
//     }
// });
// window.deleteOrderApp = deleteOrderApp;
